// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spin_wrapper__1FhXm","container":"Spin_container__2Mah-"};